import mcsApi from '@/apis/generic/mcs';
import { message } from 'antd';

//payload_Key
export const MC_GLOBAL_UNREAD_NUM = 'MC_GLOBAL_UNREAD_NUM';

//初始化获取全局
export function getGenericMessageTotalMessageNum() {
  return (dispatch, getState) =>
    mcsApi
      .genericMessageTotalMessageNum()
      .then(({ ret, data, msg } = {}) => {
        if (ret === '0') {
          dispatch({
            type: MC_GLOBAL_UNREAD_NUM,
            payload: data?.data || 0,
          });
        } else {
          message.error(`${msg || '未读信息总数获取异常,请您稍后重试！'}`);
        }
      })
      .catch((err) => {
        message.error(err);
      });
}

//store state
const initialState = {
  mcGlobalUnreadNum: 0,
};

//reducer
export default function mcGlobalUnreadNum(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MC_GLOBAL_UNREAD_NUM: {
      return { ...state, ...{ mcGlobalUnreadNum: payload } };
    }
    default: {
      return { ...state };
    }
  }
}
